import React from 'react';
import cn from 'classnames';
import { ButtonBase as MuiButton } from '@material-ui/core';

import { Icon } from '@brandandcelebrities/kolkit';

import styles from './Button.module.scss';

type Props = React.PropsWithChildren<{
  theme?: 'primary' | 'secondary';
}>;

const Button = ({ theme, children }: Props) => {
  const cnButton = cn(styles.button, theme === 'primary' ? styles.primary : styles.secondary);

  return (
    <MuiButton className={cnButton}>
      {children}
      <Icon
        label="arrow-circle-right"
        width={26}
        theme={theme === 'primary' ? 'solid' : 'thin'}
        className={styles.icon}
      />
    </MuiButton>
  );
};

export default Button;
